import React from 'react';
import { Chip, Tooltip } from '@mui/material';
import WorkspacePremiumIcon from '@mui/icons-material/WorkspacePremium';
import LocalOfferOutlinedIcon from '@mui/icons-material/LocalOfferOutlined';
import RocketLaunchOutlinedIcon from '@mui/icons-material/RocketLaunchOutlined';
import { isAdmin, isParent } from '../../utils/roles';

export default function SubscriptionChip({ user, getPlanInfo, onOpenPricing, t }) {
  if (isAdmin(user) || isParent(user)) return null;

  const info = getPlanInfo(user);
  const isPro = info.short === t('subscription.proShort');
  const isTrial = info.short === t('subscription.trialShort');
  const isFree = info.short === t('subscription.freeShort');
  const isNoPlan = info.short === t('subscription.noPlanShort');
  const chipColor = isPro ? 'primary' : ((isTrial || isNoPlan) ? 'warning' : 'default');
  const chipVariant = isPro ? 'filled' : ((isTrial || isNoPlan) ? 'filled' : 'outlined');
  const icon = isPro
    ? <WorkspacePremiumIcon sx={{ fontSize: 16 }} />
    : (isTrial ? <RocketLaunchOutlinedIcon sx={{ fontSize: 16 }} /> : <LocalOfferOutlinedIcon sx={{ fontSize: 16 }} />);

  return (
    <Tooltip title={info.full}>
      <Chip
        size="small"
        label={info.short}
        color={chipColor}
        variant={chipVariant}
        onClick={onOpenPricing}
        icon={icon}
        sx={{
          color: '#fff',
          backgroundColor: '#e65100',
          '& .MuiChip-icon': { color: '#fff' },
          '& .MuiChip-label': { backgroundColor: 'transparent' },
          '&.MuiChip-outlined': { borderColor: '#e65100' },
          '&:hover': { backgroundColor: '#cf4a00' },
          '&.MuiChip-clickable:hover': { backgroundColor: '#cf4a00' },
          '&.MuiChip-outlined:hover': { backgroundColor: '#cf4a00' },
          '&.Mui-focusVisible': { backgroundColor: '#cf4a00' }
        }}
      />
    </Tooltip>
  );
}
